import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
  flex: 1 0 auto;

  @media ${queries.less.sm} {
    padding-bottom: 56px;
    max-height: none;
  }
`

const StatusCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;

  @media ${queries.more.mdxs} {
    align-items: flex-start;
    gap: 24px;
    flex-direction: row;
  }
`
const Button = styled.button`
  display: flex;
  padding: 10px 16px;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  border: none;
  color: text-primary;
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.4px;
  transition: all 0.2s ease-in-out;

  &:focus {
    outline: none;
  }
`

const OutlineButton = styled(Button)`
  background: transparent;
  border: 1px solid #979797;
  &:hover {
    background: #f7f7f7;
  }

  &:active {
    background: #e7e7e7;
  }
`

const SuccessButton = styled(Button)`
  background: #61c478;
  color: #fff;
  &:hover {
    background: #4daf5a;
  }
  &:active {
    background: #3e8e46;
  }
`

const BlackButton = styled(Button)`
  background: #000;
  color: #fff;
  &:hover {
    background: #333;
  }
  &:active {
    background: #111;
  }
`

const PrimaryButton = styled(Button)`
  background: #7367f0;
  color: #fff;
  &:hover {
    background: #5e54e2;
  }
  &:active {
    background: #4a43c1;
  }
`

const SplitView = styled.div`
  display: flex;
  align-items: stretch;
  gap: 24px;
  height: auto;
  position: relative;
  @media ${queries.less.mdxs} {
    align-self: stretch;
    flex-direction: column-reverse;
    align-items: stretch;
  }
`

const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  gap: 24px;
  align-self: stretch;
  flex: 1 1 auto;

  @media ${queries.more.mdxs} {
    max-width: calc(50% - 12px);
  }
`

const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  gap: 24px;
  flex: 1 0 auto;
  height: auto;
  @media ${queries.more.mdxs} {
    max-width: calc(50% - 12px);
  }
`

const Box = styled.div(
  ({
    padding = '24px',
    flexDirection = 'column',
    gap = '24px',
    background = '#fff',
    flex = 'none',
    alignItems = 'flex-start',
  }) => `
  display: flex;
  padding: ${padding};
  flex-direction: ${flexDirection};
  align-items: ${alignItems};
  gap: ${gap};
  align-self: stretch;
  border-radius: 8px;
  flex: ${flex};
  border: 1px solid var(--colorBorder, rgba(0, 0, 0, 0.15));
  background: ${background};
  align-self: stretch;
  overflow: hidden;
`
)

const Title = styled.div`
  color: #2f2b3d;
  opacity: 0.9;
  /* Heading 2 - Mobile */
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.4px;
  flex: 1 0 0;
`

const Styles = {
  StatusCardWrapper,
  Container,
  Button,
  OutlineButton,
  SuccessButton,
  BlackButton,
  PrimaryButton,
  SplitView,
  LeftContent,
  RightContent,
  Box,
  Title,
}

export default Styles
